import React from "react";
import ".././App.css";

function PageHeader(props) {
  return (
    <>
      <div className="text-sm font-semibold pr-0">{props.title}</div>
    </>
  );
}

export default PageHeader;
